// Beach Super Theme - Ocean vibes with animated task backgrounds
const beachSuper = {
    id: "beachSuper",
    name: "Rannalla 🏖️",
    price: 150,
    main: "#0891b2",
    light: "#22d3ee",
    dark: "#0e7490",
    bg: "#e0f7fa",
    darkBg: "#0c2d3d",
    contrastText: "#e0f7fa",
    isSuper: true,
    isDarkTheme: false,
    shape: "pill",
    surfaces: {
        // Light mode
        lightBg: '#b2ebf2',
        lightPaper: '#e0f7fa',
        lightContainer: '#e0f7fa',
        lightOnSurface: '#003540',
        lightOnSurfaceVariant: '#2a6070',
        lightOutline: '#4d99aa',
        // Dark mode
        containerLowest: '#0c2d3d',
        containerLow: '#051820',
        container: '#0c2d3d',
        containerHigh: '#14404e',
        containerHighest: '#1c5060',
        bright: '#246070',
        onSurface: '#d8f8ff',
        onSurfaceVariant: '#90d0e0',
        outline: '#4d99aa',
        outlineVariant: '#2a6070',
        // Button colors — primary
        primaryContainer: '#22d3ee',
        onPrimaryContainer: '#003540',
        // Button colors — secondary (outlined)
        secondaryContainer: '#0a3d50',
        onSecondaryContainer: '#90d0e0',
        // Button colors — secondary (filled)
        secondary: '#22d3ee',
        onSecondary: '#003540',
        secondaryLight: '#0e7490',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#e0f7fa',
        onInverseSurface: '#0c2d3d',
        inverseSurfaceLight: '#0c2d3d',
        onInverseSurfaceLight: '#d8f8ff',
        // Button colors — label/text
        labelColor: '#22d3ee',
        labelColorLight: '#0e7490',
        // Status colors
        success: '#4caf50',
        successLight: '#81c784',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    animations: {
        avatar: "float",
        taskComplete: "profileEffect",
        completionGlow: true,
        buttonHover: "shimmer",
        profileEffect: {
            src: "/uploads/profile-effects/starfall-tides/effect.json",
            width: 450,
            height: 880,
            scaleToCard: true,
        },
    },
    nameplate: {
        light: {
            src: "/uploads/profile-effects/starfall-tides-green/bg.json",
            animateFirst: true,
        },
        dark: {
            src: "/uploads/profile-effects/starfall-tides-nightshade/bg.json",
            animateFirst: true,
        },
    },
    effects: {
        glowColor: "#22d3ee50",
    },
    modes: {
        light: {
            background: "linear-gradient(180deg, #87ceeb 0%, #e0f7fa 30%, #f5e6d3 100%)",
            cardBg: "rgba(255, 255, 255, 0.85)",
            taskPendingText: "#ffffff",
            taskCompleteBg: "transparent",
            taskCompleteBackground: "linear-gradient(180deg, #87ceeb 0%, #e0f7fa 50%, #f5e6d3 100%)",
            taskCompleteText: "#0891b2",
            taskCompleteTextSecondary: "#0e7490",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(8, 145, 178, 0.5)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
        },
        dark: {
            background: "linear-gradient(180deg, #0c2d3d 0%, #0a2233 50%, #071822 100%)",
            cardBg: "rgba(8, 145, 178, 0.15)",
            taskPendingText: "#ffffff",
            taskCompleteBg: "transparent",
            taskCompleteBackground: "linear-gradient(180deg, #0e4d6e 0%, #0c3a52 50%, #0a2d40 100%)",
            taskCompleteText: "#ffffff",
            taskCompleteTextSecondary: "rgba(255,255,255,0.75)",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(8, 145, 178, 0.5)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
        },
    },
    components: {
        card: {
            borderRadius: "50px",
            border: "1px solid rgba(8, 145, 178, 0.15)",
            boxShadow: "0 4px 20px rgba(8, 145, 178, 0.1)",
        },
        button: { borderRadius: "50px" },
        chip: { borderRadius: "50px" },
        progressBar: { borderRadius: 50 },
    },
};

export default beachSuper;
